import { Image, Pressable, Text } from "react-native";
import ScCheckbox from "../../ui-kit/checkbox";

export type SelectableItem = Readonly<{
  itemId: string;
  displayName?: string;
  userName?: string;
  profileImageUrl?: string;
}>;

type ItemRowProps = Readonly<{
  item: SelectableItem;
  selected: boolean;
  onToggle: () => void;
}>;

const ItemRow = ({ item, selected, onToggle }: ItemRowProps) => {
  return (
    <Pressable
      onPress={onToggle}
      className="flex-row items-center gap-3 py-3 px-1 hover:rounded-lg hover:bg-ash-3"
    >
      <Image
        source={
          item.profileImageUrl
            ? { uri: item.profileImageUrl }
            : require("@/src/assets/images/default-group-profile.png")
        }
        className="rounded-full"
        style={{ height: 44, width: 44 }}
      />
      <Text className="flex-1 text-sm font-medium text-onyx">
        {item.displayName ?? item.userName}
      </Text>
      <ScCheckbox value={selected} onChange={onToggle} />
    </Pressable>
  );
};

export default ItemRow;
